<template>
  <button
    type="button"
    :disabled="isDisabled"
    :class="['UIButtonIcon', { 'UIButtonIcon--disabled': isDisabled }]"
  >
    <UIIcon class="UIButtonIcon__icon" :name="icon" />
  </button>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { IIcons } from '../icons/types'
import UIIcon from '../icons/UIIcon.vue'

defineProps({
  icon: { type: String as PropType<IIcons>, required: true },
  isDisabled: { type: Boolean },
})
</script>

<style scoped lang="scss">
.UIButtonIcon {
  @include trans;
  --icon-size: var(--size, 1rem);
  --icon-color: var(--color, #{$newcolor-secondary-main});
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &.UIButtonIcon--disabled {
    pointer-events: none;
  }

  &:hover {
    --icon-color: #{$newcolor-primary-light};

    &:before {
      opacity: 0.3;
      height: calc(var(--icon-size) + 1rem);
      width: calc(var(--icon-size) + 1rem);
    }
  }

  &:before {
    position: absolute;
    height: 20px;
    width: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: 50% 50%;
    content: '';
    background-color: $newcolor-grey-200;
    border-radius: 10px;
    opacity: 0;
    transition: all 0.3s;
  }

  .UIButtonIcon__icon {
    --size: var(--icon-size);
    --color: var(--icon-color);
    z-index: 1;
  }
}
</style>
